// extracted by mini-css-extract-plugin
module.exports = {"afaImage":"AfaImage_afaImage__8BUq4"};